module.exports = __webpack_public_path__ + "img/E2 Pred Up.d58a35e9.png";